export default __webpack_public_path__ + "static/media/delete.6d94ab65.svg";